<script lang="ts">
    import { mustNeverExist } from "@repo/utils";
    import Throw from "./throw.svelte";

    const { value }: { value: never } = $props();
</script>

<Throw error={mustNeverExist(value)} />
